import * as React from 'react';
import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useFormik } from 'formik';
import * as yup from 'yup';
import axios from 'utils/axios';
import { MenuItem, Select } from '@mui/material';
// import FormLabel from '@mui/material/FormLabel';
// import FormControl from '@mui/material/FormControl';
// import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import SecondaryButton from 'components/buttons/SecondaryButton';
import PrimaryButton from 'components/buttons/PrimaryButton';
// import getToken from 'src/utils/getToken';

// import {
//    Formik,
//    FormikHelpers,
//    FormikProps,
//    Form,
//    Field,
//    FieldProps,
//  } from 'formik';

// type Props = {
//   submission_id: any;
//   submission_author_id: any;
//   open: boolean;
//   handleOpen: () => void;
//   handleClose: () => void;
// };

function AuthorEditor({
    submission_id,
    id,
    handleOpen,
    handleClose,
    open,
    ...other
}) {
    const [countryList, setCountryList] = useState([]);

    const phoneRegExp =
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

    const validationSchema = yup.object({
        name: yup
            .string()
            .trim()
            .min(2, 'Please enter a valid name')
            .max(50, 'Please enter a valid name')
            .required("Please specify author's name"),
        institution: yup
            .string()
            .trim()
            .required("Please specify author's institution"),
        city: yup.string().trim().required("Please specify author's city"),
        country: yup.string().required("Please specify author's country"),
        isCorresponding: yup.boolean(),
        email: yup.string().when('isCorresponding', {
            is: true,
            then: yup
                .string()
                .trim()
                .email('Please enter a valid email address')
                .required('Email is required.'),
        }),
        phoneNumber: yup.string().when('isCorresponding', {
            is: true,
            then: yup
                .string()
                .trim()
                .matches(phoneRegExp, 'Phone number is not valid')
                .min(9, 'Please enter a valid phone number')
                .max(14, 'Please enter a valid phone number')
                .required('Please specify your phone number'),
        }),
        address: yup.string().when('isCorresponding', {
            is: true,
            then: yup.string().trim().required('Address is required.'),
        }),
        postalCode: yup.number().when('isCorresponding', {
            is: true,
            then: yup
                .number()
                .typeError('Postal code must be a number')
                .required('Postal code is required.'),
        }),
    });

    const initialValues = {
        submission: submission_id,
        id,
        name: '',
        institution: '',
        city: '',
        country: '96426f47-2dbb-bf82-1dbc-afbf07d020a8',
        phoneNumber: '',
        email: '',
        address: '',
        postalCode: '',
        isCorresponding: false,
        isPresenter: false,
    };

    const handleSubmit = async (values, actions) => {
        actions.setSubmitting(false);
        if (values.id) {
            await axios
                .patch('/api/submission-author/' + values.id, values)
                .then(() => {
                    handleClose();
                })
                .catch((error) => {
                    console.log('err submission_author_save : ', error);
                });
        } else {
            delete values.id;
            await axios
                .post('/api/submission-author', values)
                .then(() => {
                    handleClose();
                })
                .catch((error) => {
                    console.log('err submission_author_save : ', error);
                });
        }
    };

    useEffect(() => {
        const loadAuthor = async (id) => {
            if (id) {
                await axios
                    .get('/api/submission-author/' + id)
                    .then((response) => {
                        if (response.data !== 'TOKEN_INVALID') {
                            setnewInitValues((newInitValues) => ({
                                ...newInitValues,
                                name: response.data.name,
                            }));

                            setDialogKey((dialogKey) => dialogKey + 1);
                            formik.setFieldValue('name', response.data.name);
                            formik.setFieldValue(
                                'institution',
                                response.data.institution,
                            );
                            formik.setFieldValue('city', response.data.city);
                            formik.setFieldValue(
                                'country',
                                response.data.country.id,
                            );
                            formik.setFieldValue(
                                'phoneNumber',
                                response.data.phoneNumber,
                            );
                            formik.setFieldValue('email', response.data.email);
                            formik.setFieldValue(
                                'address',
                                response.data.address,
                            );
                            formik.setFieldValue(
                                'postalCode',
                                response.data.postalCode,
                            );
                            formik.setFieldValue(
                                'isCorresponding',
                                response.data.isCorresponding,
                            );
                            response.data.isCorresponding
                                ? setDisplayCorrespondingProp('block')
                                : removeCorrespondingProp();
                            formik.setFieldValue(
                                'isPresenter',
                                response.data.isPresenter,
                            );
                            setCorresponding(response.data.isCorresponding);
                            setPresenter(response.data.isPresenter);
                        }
                    })
                    .catch((err) => {
                        console.log('err on submission_author_load : ', err);
                    });
            } else {
                removeCorrespondingProp();
                setDialogKey((dialogKey) => dialogKey + 1);
                formik.setFieldValue('name', '');
                formik.setFieldValue('institution', '');
                formik.setFieldValue('city', '');
                formik.setFieldValue('email', '');
                formik.setFieldValue('phoneNumber', '');
                formik.setFieldValue('address', '');
                formik.setFieldValue('postalCode', '');
                formik.setFieldValue('isCorresponding', false);
                formik.setFieldValue('isPresenter', false);
                setCorresponding(false);
                setPresenter(false);
            }
        };

        const loadCountry = async () => {
            await axios
                .get('api/country')
                .then((res) => setCountryList(res.data))
                .catch((err) => console.log(err));
        };

        loadAuthor(id);
        loadCountry();
    }, []);

    const removeCorrespondingProp = () => {
        setDisplayCorrespondingProp('none');
        formik.setFieldValue('email', '');
        formik.setFieldValue('phoneNumber', '');
        formik.setFieldValue('address', '');
        formik.setFieldValue('postalCode', '');
    };
    const handleCheckbox = (event) => {
        if (event.target.name === 'isCorresponding') {
            setCorresponding(event.target.checked);
            event.target.checked
                ? setDisplayCorrespondingProp('block')
                : removeCorrespondingProp();
        }

        if (event.target.name === 'isPresenter') {
            setPresenter(event.target.checked);
        }

        setRole({
            ...role,
            [event.target.name]: event.target.checked,
        });

        formik.handleChange(event);
    };

    const [newInitValues, setnewInitValues] = useState(initialValues);
    const [displayCorrespondingProp, setDisplayCorrespondingProp] =
        useState('none');

    const [role, setRole] = React.useState({
        corresponding: initialValues.corresponding,
        presenter: initialValues.presenter,
    });

    const [corresponding, setCorresponding] = useState(false);
    const [presenter, setPresenter] = useState(false);

    const [dialogKey, setDialogKey] = React.useState(0);

    const formik = useFormik({
        initialValues: newInitValues || {
            submission: submission_id,
            id,
            name: '',
            institution: '',
            city: '',
            country: '96426f47-2dbb-bf82-1dbc-afbf07d020a8',
            phoneNumber: '',
            email: '',
            address: '',
            postalCode: '',
            isCorresponding: true,
            isPresenter: false,
        },
        validationSchema: validationSchema,
        onSubmit: handleSubmit,
    });

    return (
        <Dialog
            key={dialogKey}
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
        >
            <form onSubmit={formik.handleSubmit}>
                <DialogTitle>Author</DialogTitle>
                <DialogContent>
                    <Box display={'flex'} flexDirection={'column'}>
                        <Box mx={1}>
                            <TextField
                                autoFocus
                                margin="dense"
                                fullWidth
                                id="name"
                                label="Full Name *"
                                variant="outlined"
                                name={'name'}
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.name &&
                                    Boolean(formik.errors.name)
                                }
                                // @ts-ignore
                                helperText={
                                    formik.touched.name && formik.errors.name
                                }
                            />
                        </Box>
                        <Box mx={1}>
                            <TextField
                                margin="dense"
                                fullWidth
                                label="Institution"
                                variant="outlined"
                                name={'institution'}
                                value={formik.values.institution}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.institution &&
                                    Boolean(formik.errors.institution)
                                }
                                // @ts-ignore
                                helperText={
                                    formik.touched.institution &&
                                    formik.errors.institution
                                }
                            />
                        </Box>
                        <Box mx={1}>
                            <TextField
                                margin="dense"
                                fullWidth
                                label="City *"
                                variant="outlined"
                                name={'city'}
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.city &&
                                    Boolean(formik.errors.city)
                                }
                                // @ts-ignore
                                helperText={
                                    formik.touched.city && formik.errors.city
                                }
                            />
                        </Box>
                        <Box mx={1} sx={{ my: 0.5 }}>
                            <Select
                                margin="dense"
                                fullWidth
                                label="Country *"
                                variant="outlined"
                                name={'country'}
                                value={formik.values.country}
                                onChange={formik.handleChange}
                            >
                                {countryList &&
                                    countryList.map((item, key) => (
                                        <MenuItem key={key} value={item.id}>
                                            {item.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                            {formik.touched.country && (
                                <FormHelperText
                                    error
                                    sx={{
                                        ml: '14px',
                                        fontSize: '0.75rem',
                                        fontWeight: 400,
                                    }}
                                >
                                    {formik.errors.country}
                                </FormHelperText>
                            )}
                        </Box>
                        <Box display={displayCorrespondingProp}>
                            <Box mx={1}>
                                <TextField
                                    margin="dense"
                                    fullWidth
                                    label="Phone Number"
                                    variant="outlined"
                                    name={'phoneNumber'}
                                    value={formik.values.phoneNumber}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.phoneNumber &&
                                        Boolean(formik.errors.phoneNumber)
                                    }
                                    // @ts-ignore
                                    helperText={
                                        formik.touched.phoneNumber &&
                                        formik.errors.phoneNumber
                                    }
                                />
                            </Box>
                            <Box mx={1}>
                                <TextField
                                    margin="dense"
                                    fullWidth
                                    label="Email Address"
                                    type="email"
                                    variant="outlined"
                                    name={'email'}
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.email &&
                                        Boolean(formik.errors.email)
                                    }
                                    // @ts-ignore
                                    helperText={
                                        formik.touched.email &&
                                        formik.errors.email
                                    }
                                />
                            </Box>
                            <Box mx={1}>
                                <TextField
                                    margin="dense"
                                    fullWidth
                                    label="Address"
                                    variant="outlined"
                                    name={'address'}
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.address &&
                                        Boolean(formik.errors.address)
                                    }
                                    // @ts-ignore
                                    helperText={
                                        formik.touched.address &&
                                        formik.errors.address
                                    }
                                />
                            </Box>
                            <Box mx={1}>
                                <TextField
                                    margin="dense"
                                    fullWidth
                                    label="Postal Code"
                                    variant="outlined"
                                    name={'postalCode'}
                                    value={formik.values.postalCode}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.postalCode &&
                                        Boolean(formik.errors.postalCode)
                                    }
                                    // @ts-ignore
                                    helperText={
                                        formik.touched.postalCode &&
                                        formik.errors.postalCode
                                    }
                                />
                            </Box>
                        </Box>
                        <Box>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={corresponding}
                                        value={formik.values.corresponding}
                                        name={'isCorresponding'}
                                        onChange={handleCheckbox}
                                    />
                                }
                                label="Corresponding"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={presenter}
                                        value={formik.values.presenter}
                                        name={'isPresenter'}
                                        onChange={handleCheckbox}
                                    />
                                }
                                label="Presenter"
                            />
                        </Box>

                        <Box padding={2} maxWidth={600}>
                            Notes:
                            <ul>
                                <li>
                                    Author’s names should be first and middle
                                    name as initials and last (surname) name
                                    only. (i.e. J. Smith or J.B. Smith) (No
                                    title such as Prof. Dr. PhD or MD should be
                                    used)
                                </li>
                                <li>
                                    The first author should be your name and
                                    must be corresponding author and presenter
                                </li>
                                <li>
                                    Other than the first author is a co-author
                                </li>
                            </ul>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', gap: 1, p: 2 }}>
                    <SecondaryButton onClick={handleClose} variant="outlined">
                        Cancel
                    </SecondaryButton>
                    <PrimaryButton type="submit" variant="contained">
                        Save
                    </PrimaryButton>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default AuthorEditor;
